import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'newlineToBreak',
  standalone: true,
})
export class NewlineToBreakPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    const colonIndex = value.indexOf(':');

    // Only apply formatting if colon exists and is followed by <br>
    if (colonIndex !== -1 && value.slice(colonIndex + 1).trim().startsWith('<br>')) {
      const label = value.substring(0, colonIndex + 1); // include colon
      const rest = value.substring(colonIndex + 1);

      const items = rest
        .split('<br>')
        .filter(item => item.trim())
        .map(item => `${item.trim()}`)
        .join('<br>');

      return `${label}<br>${items}`; // keep colon on first line
    }

    // Default: preserve line breaks only
    return value.replace(/<br>/g, '<br>');
  }
}

